export const REDUCER_INDEX = 'holidays';
export const BASE_URL = 'holidays';

export const PATHS = {
  BASE_URL,
  CREATE_HOLIDAY: `${BASE_URL}/create`,
  EDIT_HOLIDAY: `${BASE_URL}/edit/:holidayId`,
} as const;

export const getRouteToHolidaysHome = (): string => PATHS.BASE_URL;

export const getRouteCreateHoliday = (): string => PATHS.CREATE_HOLIDAY;

export const getRouteEditHoliday = (holidayId: string): string =>
  PATHS.EDIT_HOLIDAY.replace(':holidayId', holidayId);
